import React from 'react'

import { IMaskInput } from 'react-imask'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'

type InputCnpjProps = FieldProps & {
  id?: string
  className?: string
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  tabIndex?: number
}

export const InputCnpj = ({
  name,
  label,
  className,
  container,
  error,
  withoutError = false,
  ...rest
}: InputCnpjProps) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <div {...container}>
      {label}
      <IMaskInput
        mask="00.000.000/0000-00"
        value={field.value}
        onAccept={(value: string) => helpers.setValue(value)}
        onBlur={() => helpers.setTouched(true)}
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
